import { render, staticRenderFns } from "./modalRealizarPedidoAbast.vue?vue&type=template&id=0d74b88e&scoped=true&"
import script from "./modalRealizarPedidoAbast.vue?vue&type=script&lang=js&"
export * from "./modalRealizarPedidoAbast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d74b88e",
  null
  
)

export default component.exports